import { createApiHook, useApi } from "../utils/apiUtils";

const useUpdateAnswerType = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const updateAnswerType = async (id, payload) => {
    startLoading();
    const response = await apiPatch(`/answer_types/${id}`, "Error al actualizar el tipo de respuesta", payload);
    setResponse(response);

    if (response?.error) {
      const err = new Error(response.error.message || "No se pudo actualizar el tipo de respuesta");
      err.backend = response.error;
      throw err;
    }
    return response;
  };

  return { updateAnswerType, data, loading, error };
};

export default useUpdateAnswerType;
